import { render, staticRenderFns } from "./SwapPanel.vue?vue&type=template&id=2dae9016&scoped=true"
import script from "./SwapPanel.vue?vue&type=script&lang=js"
export * from "./SwapPanel.vue?vue&type=script&lang=js"
import style0 from "./SwapPanel.vue?vue&type=style&index=0&id=2dae9016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae9016",
  null
  
)

export default component.exports